import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedStationType: {},
    stationTypes: [],
    publishedStationTypes: [],
  }),

  mutations: {
    setSelectedStationType(state, stationType) {
      Vue.set(state, "selectedStationType", stationType);
    },
    setStationTypes(state, stationTypes) {
      Vue.set(state, "stationTypes", stationTypes);
    },
    setPublishedStationTypes(state, publishedStationTypes) {
      Vue.set(state, "publishedStationTypes", publishedStationTypes);
    },
    setDefaultStationTypeModule(state) {
      Vue.set(state, "selectedStationType", {});
      Vue.set(state, "stationTypes", []);
      Vue.set(state, "publishedStationTypes", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createStationType: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/station-types/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedStationTypes: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/entity/published").then((response) => {
        context.commit("setPublishedStationTypes", response.data);
        return response.data;
      });
    },

    loadStationTypes: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/entity").then((response) => {
        context.commit("setStationTypes", response.data);
        return response.data;
      });
    },

    loadStationType: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadSelectedStationTypeHistory: (context, stationType) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/history/" + stationType.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteStationType: (context, stationType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/station-types/entity/" + stationType.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          stationType.intents = intents;
          stationType.intentId = response.data.id;
          return stationType;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftStationType: (context, stationType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/station-types/draft/" + stationType.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishStationType: (context, stationType) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/publish/" + stationType.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectStationType: (context, stationType) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/reject/" + stationType.intentId).then((response) => {
        helper.recallOrRejectEntity(stationType, "station_type");
        return response.data;
      });
    },
    sendToApprovalStationTypes: (context, stationType) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/sendToApproval/" + stationType.intentId).then((response) => {
        if (stationType.intents[0].type === "CREATE_STATION_TYPE") {
          stationType.intents[0].status = "WAITING_APPROVAL";
        } else if (stationType.intents[0].type === "UPDATE_STATION_TYPE") {
          stationType.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallStationType: (context, stationType) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/recall/" + stationType.intentId).then((response) => {
        helper.recallOrRejectEntity(stationType, "station_type");
        return response.data;
      });
    },
    cancelStationType: (context, stationType) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/cancel/" + stationType.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedStationType: (state) => {
      return state.selectedStationType;
    },
    getStationTypes: (state) => {
      return state.stationTypes;
    },
    getPublishedStationTypes: (state) => {
      return state.publishedStationTypes;
    },
  },
};
